import urlExt from '@w/utils/url';
import VisibilityObserver from '@w/utils/visibility-observer';
import { DirectiveOptions } from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { send, track } from '@kd/loggerh5';

function paramsParser(params: string) {
  let result;
  if (params.match(/&/) !== null) {
    result = urlExt.queryToJson(params);
  } else {
    params.match('event_id') !== null && (result = urlExt.queryToJson(params));
    params.match('event_id') === null && (result = { name: params });
  }
  return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function loggerPVHandler(value: any) {
  if (typeof value === 'string') {
    const loggerContent = paramsParser(value);

    send(loggerContent?.name, {
      type: 'pv',
      event_id: '',
      ...loggerContent
    });
  } else {
    const { oldLogName = '', newLogName = '', ...logParams } = value;

    newLogName &&
      track(newLogName, logParams);

    oldLogName &&
      send(oldLogName, {
        type: 'pv',
        event_id: '',  // eslint-disable-line
        ...logParams
      });
  }
  // isDebug && showOverlay(value, el, 1);
}

function loggerClickHandler(target: MouseEvent, el: HTMLElement, value: string) {
  const loggerClickHits = 'loggerClickHits' in el.dataset ? el.dataset.loggerClickHits : '1';
  el.dataset.loggerClickHits = loggerClickHits;
  const loggerContent = paramsParser(value);
  send(value, {
    type: 'click',
    offsetX: target.offsetX,
    offsetY: target.offsetY,
    hits: loggerClickHits,
    event_id: '',  // eslint-disable-line
    ...loggerContent
  });
}

const loggerPV: DirectiveOptions = {
  bind: (el, { value, arg }, vnode) => {
    if (!value) {
      return;
    }
    if (typeof IntersectionObserver === 'undefined') {
      console.warn('[loggerPV] IntersectionObserver API is not available in your browser.');
    } else {
      (el as any)._kd_logger = new VisibilityObserver(el, arg || '', vnode, visible => {  // eslint-disable-line
        visible && loggerPVHandler(value);
      });
    }
  },
  unbind: el => {
    const observer = (el as any)._kd_logger  // eslint-disable-line
    if (observer) {
      observer.destroy();
      delete (el as any)._kd_logger  // eslint-disable-line
    }
  },
  update: (el, { value, oldValue, arg }, vnode, oldVnode) => {
    if (value === oldValue) {
      return;
    }
    const observer = (el as any)._kd_logger  // eslint-disable-line
    if (!value) {
      loggerPV.unbind && loggerPV.unbind(el, {} as DirectiveBinding, vnode, oldVnode);
      return;
    }
    if (observer) {
      observer.create(el, vnode, () => {
        loggerPVHandler(value);
      });
    } else {
      loggerPV.bind && loggerPV.bind(el, { value, arg } as DirectiveBinding, vnode, oldVnode);
    }
  }
};
const loggerClick: DirectiveOptions = {
  bind: (el, { value }, vnode) => {
    vnode &&
      vnode.context &&
      vnode.context.$nextTick(() => {
        el.addEventListener(
          'click',
          target => {
            loggerClickHandler(target, el, value);
          },
          false
        );
      });
  },
  unbind: (el, { value }) => {
    const loggerClickHits = el.dataset.loggerClickHits;
    if (loggerClickHits) {
      el.removeEventListener(
        'click',
        target => {
          loggerClickHandler(target, el, value);
        },
        false
      );
    }
  },
  update: (el, { value, oldValue }, vnode, oldVnode) => {
    if (value === oldValue) {
      return;
    }
    const loggerClickHits = el.dataset.loggerClickHits;
    if (!value) {
      loggerClick.unbind && loggerClick.unbind(el, { value } as DirectiveBinding, vnode, oldVnode);
      return;
    }
    if (!loggerClickHits) {
      loggerClick.bind && loggerClick.bind(el, { value } as DirectiveBinding, vnode, oldVnode);
    }
  }
};

export default {
  loggerPV,
  loggerClick
};
